import React, { useEffect, useState } from "react";
import "./Auth.css";
import loginVec from "../../Assets/Images/reset2Vec.webp";
import brandLogo from "../../Assets/Images/brandLogo.png";
import { MdOutlineRemoveRedEye, MdOutlineVisibilityOff } from "react-icons/md";
import { useFormik } from "formik";
import * as Yup from "yup";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import {
  postApiCaller,
  postApiCallerForgotPassword,
} from "../../Libs/apiCaller";

const ResetPassword = () => {
  const [showPassword, setShowPassword] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (localStorage.getItem("isPassChanged")) {
      navigate("/sign-in");
    }
  }, []);

  const formik = useFormik({
    initialValues: {
      password: "",
      confirmPassword: "",
    },
    validationSchema: Yup.object({
      password: Yup.string()
        .min(6, "Password must be at least 6 characters")
        .matches(/[A-Z]/, "Password must contain at least one uppercase letter")
        .matches(/[a-z]/, "Password must contain at least one lowercase letter")
        .matches(/[0-9]/, "Password must contain at least one number")
        .matches(
          /[!@#$%^&*(),.?":{}|<>]/,
          "Password must contain at least one special character"
        )
        .required("Password is required"),
      confirmPassword: Yup.string()
        .oneOf([Yup.ref("password"), null], "Passwords must match")
        .required("Confirm password is required"),
    }),
    onSubmit: async (values) => {
      setIsLoading(true);
      // API call
      const endPoint = "auth/forgot_password";
      const payload = {
        phone: location.state.phone,
        NewPassword: values.confirmPassword,
      };
      const response = await postApiCallerForgotPassword(endPoint, payload);
      if (response?.status === 200) {
        localStorage.setItem("isPassChanged", true);
        navigate("/successful");
        localStorage.removeItem("accessToken");
        formik.resetForm();
      } else {
        toast.error(response?.response?.data?.message);
      }
      setIsLoading(false);
    },
  });

  return (
    <section className="bg-login p-6 md:p-4 pb-16 sm:pb-0 min-h-screen flex items-center justify-center
overflow-x-hidden">
      <div className="grid grid-cols-1 md:grid-cols-2 items-stretch w-full max-w-8xl mx-auto gap-0 md:gap-10">
        {/* Right Section (Image & Text) */}
        <div
          className="hidden md:grid relative grid-cols-1 h-full min-h-[calc(100vh-40px)] bg-cover bg-top-center rounded-xl"
          style={{ backgroundImage: `url(${loginVec})` }}
        >
          <div className="absolute inset-0 bg-black bg-opacity-20 rounded-xl"></div>
          <div className="absolute top-0 text-left text-white p-8 w-3/4">
            <img src={brandLogo} alt="Brand Logo" className="w-20 h-20 mb-4 drop-shadow-lg" />
          </div>
          <div className="absolute bottom-4 mx-4 w-[calc(100%-2rem)] text-left rounded-lg text-white p-3 backdrop-blur-xs border border-white/30 bg-white/10">
            <p className="capitalize text-md">
              We believe communication should be simple, fast, and private.
              Whether you're chatting with friends, connecting with family, or
              collaborating with your team, our platform ensures seamless
              messaging and end-to-end security.
            </p>
          </div>
        </div>

        {/* Left Section (Form) */}
        <div className="flex items-center justify-center px-4 md:px-0">
          <div className="w-full max-w-lg ">
            <h2 className="text-3xl leading-[50px] font-bold text-gray-900 w-3/2 mb-4 capitalize">
              Reset Password
            </h2>
            <p className="text-md text-gray-500 mb-6">
              Reset your password securely and easily.
            </p>

            {/* Form */}
            <form onSubmit={formik.handleSubmit}>
              <div className="mb-6 relative">
                <label className="block text-gray-700 text-sm mb-2">
                  Password
                </label>
                <input
                  type={showPassword ? "text" : "password"}
                  className={`w-full bg-white px-4 py-3.5 rounded-lg focus:outline-none focus:ring-2 ${
                    formik.touched.password && formik.errors.password
                      ? "focus:ring-red-500 border border-red-500"
                      : "focus:ring-purple-600"
                  } pr-10`}
                  placeholder="Enter Password"
                  name="password"
                  value={formik.values.password}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                />
                <button
                  type="button"
                  className="absolute right-3 top-10 text-gray-500 hover:text-gray-700"
                  onClick={() => setShowPassword(!showPassword)}
                >
                  {showPassword ? (
                    <MdOutlineRemoveRedEye size={22} />
                  ) : (
                    <MdOutlineVisibilityOff size={22} />
                  )}
                </button>
                {formik.touched.password && formik.errors.password && (
                  <p className="text-red-500 text-sm mt-1 errorMsg">
                    {formik.errors.password}
                  </p>
                )}
              </div>

              <div className="mb-6 relative">
                <label className="block text-gray-700 text-sm mb-2">
                  Confirm Password
                </label>
                <input
                  type={showConfirmPassword ? "text" : "password"}
                  className={`w-full bg-white px-4 py-3.5 rounded-lg focus:outline-none focus:ring-2 ${
                    formik.touched.confirmPassword &&
                    formik.errors.confirmPassword
                      ? "focus:ring-red-500 border border-red-500"
                      : "focus:ring-purple-600"
                  } pr-10`}
                  placeholder="Confirm Password"
                  name="confirmPassword"
                  value={formik.values.confirmPassword}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                />
                <button
                  type="button"
                  className="absolute right-3 top-10 text-gray-500 hover:text-gray-700"
                  onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                >
                  {showConfirmPassword ? (
                    <MdOutlineRemoveRedEye size={22} />
                  ) : (
                    <MdOutlineVisibilityOff size={22} />
                  )}
                </button>
                {formik.touched.confirmPassword &&
                  formik.errors.confirmPassword && (
                    <p className="text-red-500 text-sm mt-1 errorMsg">
                      {formik.errors.confirmPassword}
                    </p>
                  )}
              </div>

              <button
                type="submit"
                className="w-full bg-[var(--primary-color)] text-white py-3 rounded-full text-lg font-medium hover:bg-purple-500 transition"
                disabled={isLoading}
              >
                {isLoading ? "Loading..." : "Reset Password"}
              </button>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ResetPassword;
